import styles from "./SpiderScheduleForm.module.css"
import { Form, Col, Row } from "react-bootstrap";
import Select from "react-select";
import { daysOfWeek } from "../../../utilities/functions";
import { Button } from "react-bootstrap";
import AGTable from "../../../components/AGTable/AGTable";
import { useRef } from "react";
import Papa from "papaparse";
import { Tooltip } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';

const SpiderScheduleForm = (props) => {
    const scheduleObj = props.scheduleObj;
    const setScheduleObj = props.setScheduleObj;
    const source = props.source;
    const fileInputRef = useRef();
    const gridRef = useRef();

    const handleUploadButtonClick = () => {
        fileInputRef.current.click(); // Trigger the hidden input
    };

    const handleUploadFile = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onload = (event) => {
            const text = event.target.result;
            let data;
            if (file?.type === "text/csv"){
                const parsed = Papa.parse(text, {
                    header: true,        // Automatically use first line as headers
                    skipEmptyLines: true // Ignore empty lines
                });
                
                data = parsed.data; 
            }
            if (data){
                setScheduleObj((prev) =>{
                    return{
                        ...prev,
                        spiderArgs: [...data.map((item) => {
                            delete item._type;
                            
                            return {
                                ...item,
                            }
                        })]
                    }
                }
            )}
        };

        reader.onerror = (error) => {
            console.error('Error reading file:', error);
        };

        try{
            reader.readAsText(file);
        } catch (e){
            return
        }
        fileInputRef.current.value = '';
    }

    return (
        <div style={{overflow: 'visible'}}>

            <Form>
                <Form.Group as={Row} className="mb-3">
                        <Form.Label column sm="2">
                            Spider:
                        </Form.Label>
                        <Col sm="4">
                            <Form.Control type="text" disabled value={props?.spiderName}/>
                        </Col>
                        <Form.Label column sm="2">
                            Client:
                        </Form.Label>
                        <Col sm="4">
                            <Form.Control type="text" value={scheduleObj?.client} onChange={(e) => setScheduleObj((prev) => ({...prev, client: e.target.value}))}/>
                        </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3  d-flex align-items-center">
                        <Form.Label column sm="2">
                            Day of Week:
                        </Form.Label>
                        <Col sm="4">
                            <Select 
                                isMulti
                                menuPortalTarget={document.body} // render dropdown at body level
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                }}
                                value={scheduleObj?.dayOfWeek} 
                                options={[
                                    {
                                        label: "Every day",
                                        value: "Every day"
                                    },
                                    ...daysOfWeek.map((day) => {
                                        return {
                                            label: day,
                                            value: day
                                        }
                                    })
                                ]}
                                onChange={(e) => {
                                    if (scheduleObj?.dayOfWeek?.length < e.length){
                                        // Added new item
                                        const newItem = e.find(n => !scheduleObj?.dayOfWeek.some(o => o.value === n.value));
                                        if (newItem.value === "Every day"){
                                            // New item is every day
                                            setScheduleObj((prev) => ({
                                                ...prev,
                                                dayOfWeek: [newItem]
                                            }));
                                        } else if (e.some(obj => obj.value === "Every day")) {
                                            // Every day in list but new item is different
                                            const filteredItems = e.filter(obj => obj.value !== "Every day");
                                            setScheduleObj((prev) => ({
                                                ...prev,
                                                dayOfWeek: filteredItems,
                                                day: [{
                                                    value: "Every day",
                                                    label: "Every day"
                                                }]
                                            }));
                                        } else {
                                            // Every day is not in list and new item is also not every day
                                            setScheduleObj((prev) => ({
                                                ...prev,
                                                dayOfWeek: e
                                            }));
                                        }
                                    } else {
                                        // Removed item
                                        if (e.length > 0){
                                            setScheduleObj((prev) => ({
                                                ...prev,
                                                dayOfWeek: e
                                            }));
                                        } else {
                                            setScheduleObj((prev) => ({
                                                ...prev,
                                                dayOfWeek: [{
                                                    value: "Every day",
                                                    label: "Every day"
                                                }]
                                            }));
                                        }
                                    }
                                }}
                            />
                        </Col>
                        <Form.Label column sm="2">
                            Day of Month:
                        </Form.Label>
                        <Col sm="4">
                            <Select
                                isMulti
                                menuPortalTarget={document.body} // render dropdown at body level
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                }}
                                value={scheduleObj?.day}
                                options={[
                                    {
                                        label: "Every day",
                                        value: "Every day"
                                    },
                                    ...Array.from({ length: 31 }, (_, i) => ({
                                        value: i + 1,
                                        label: (i + 1).toString(),
                                    }))
                                ]}
                                onChange={(e) => {
                                    if (scheduleObj?.day?.length < e.length){
                                        // Added new item
                                        const newItem = e.find(n => !scheduleObj?.day.some(o => o.value === n.value));
                                        if (newItem.value === "Every day"){
                                            // New item is every day
                                            setScheduleObj((prev) => ({
                                                ...prev,
                                                day: [newItem]
                                            }));
                                        } else if ([...e].some(obj => obj.value === "Every day")) {
                                            // Every day in list but new item is different
                                            const filteredItems = e.filter(obj => obj.value !== "Every day");
                                            setScheduleObj((prev) => ({
                                                ...prev,
                                                day: filteredItems,
                                                dayOfWeek: [{
                                                    value: "Every day",
                                                    label: "Every day"
                                                }]
                                            }));
                                        } else {
                                            // Every day is not in list and new item is also not every day
                                            setScheduleObj((prev) => ({
                                                ...prev,
                                                day: e
                                            }));
                                        }
                                    } else {
                                        // Removed item
                                        if (e.length > 0){
                                            setScheduleObj((prev) => ({
                                                ...prev,
                                                day: e
                                            }));
                                        } else {
                                            setScheduleObj((prev) => ({
                                                ...prev,
                                                day: [{
                                                    value: "Every day",
                                                    label: "Every day"
                                                }]
                                            }));
                                        }
                                    }
                                }}
                            />
                        </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                        <Form.Label column sm="2">
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <span>Hour:</span>
                                <Tooltip title="Time in Sydney, Australia">
                                    <span>
                                        <InfoIcon fontSize="small" style={{ cursor: "default", color: "#666" }} />
                                    </span>
                                </Tooltip>
                            </div>
                        </Form.Label>
                        <Col sm="4">
                            <Select 
                                menuPortalTarget={document.body} // render dropdown at body level
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                }}
                                value={{value: scheduleObj?.hour, label: scheduleObj?.hour}} 
                                options={[
                                    ...Array.from({ length: 24 }, (_, i) => ({
                                        value: i < 10 ? `0${i}:00` : `${i}:00`,
                                        label: i < 10 ? `0${i}:00` : `${i}:00`,
                                    }))
                                ]}
                                onChange={(e) => {
                                    setScheduleObj((prev) => ({
                                        ...prev,
                                        hour: e.value
                                    }))
                                }}
                                />
                        </Col>
                        <Form.Label column sm="2">
                            Minute:
                        </Form.Label>
                        <Col sm="4">
                            <Select 
                                menuPortalTarget={document.body} // render dropdown at body level
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                }}
                                value={{value: scheduleObj?.minute, label: scheduleObj?.minute}} 
                                options={[
                                    ...Array.from({ length: 60 }, (_, i) => ({
                                        value: i < 10 ? `0${i}` : `${i}`,
                                        label: i < 10 ? `0${i}` : `${i}`,
                                    }))
                                ]}
                                onChange={(e) => {
                                    setScheduleObj((prev) => ({
                                        ...prev,
                                        minute: e.value
                                    }))
                                }}
                            />                      
                        </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3 align-items-center">
                        <Form.Label column sm="2">
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <span>Tag:</span>
                                <Tooltip title="Tag for all jobs, add indivudal job tags in 'unique_id' spider argument">
                                    <span>
                                        <InfoIcon fontSize="small" style={{ cursor: "default", color: "#666" }} />
                                    </span>
                                </Tooltip>
                            </div>
                        </Form.Label>
                        <Col sm="4">
                            <Form.Control type="text" value={scheduleObj?.tag} onChange={(e) => setScheduleObj((prev) => ({...prev, tag: e.target.value}))}/>
                        </Col>
                        <Form.Label column sm="2">
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <span>Argument Table:</span>
                                <Tooltip title="Table with live spider arguments, updated each week. Contact dev team for more info on how to set this up">
                                    <span>
                                        <InfoIcon fontSize="small" style={{ cursor: "default", color: "#666" }} />
                                    </span>
                                </Tooltip>
                            </div>
                        </Form.Label>
                        <Col sm="4">
                            <Form.Control type="text" value={scheduleObj?.arg_table} onChange={(e) => setScheduleObj((prev) => ({...prev, arg_table: e.target.value}))}/>
                        </Col>
                </Form.Group>
                {(scheduleObj.batch_size || source === "SpiderLibrary") && <Form.Group as={Row} className="mb-3 align-items-center">
                        <Form.Label column sm="2">
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <span>Batch Size:</span>
                                <Tooltip title="Jobs per batch">
                                    <span>
                                        <InfoIcon fontSize="small" style={{ cursor: "default", color: "#666" }} />
                                    </span>
                                </Tooltip>
                            </div>
                        </Form.Label>
                        <Col sm="4">
                            <Form.Control type="text" value={scheduleObj?.batch_size} onChange={(e) => setScheduleObj((prev) => ({...prev, batch_size: e.target.value}))}/>
                        </Col>
                        <Form.Label column sm="2">
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <span>Batch Time:</span>
                                <Tooltip title="Time in between each batch">
                                    <span>
                                        <InfoIcon fontSize="small" style={{ cursor: "default", color: "#666" }} />
                                    </span>
                                </Tooltip>
                            </div>
                        </Form.Label>
                        <Col sm="4">
                            <Form.Control type="text" value={scheduleObj?.batch_time} onChange={(e) => setScheduleObj((prev) => ({...prev, batch_time: e.target.value}))}/>
                        </Col>
                </Form.Group>}
                <div className={styles.SpiderScheduleFormArgs}>
                    <div style={{display: "flex", alignItems: "center", gap: "5px"}}>
                        <span>Arguments</span>

                    </div>
                    <div style={{display: "flex", gap: "10px"}}>
                        <Button variant="success" as="a" href="/spider_schedule_argument_template.csv" download>Download Template</Button>
                        <div>
                            <input type="file" ref={fileInputRef} onChange={handleUploadFile} style={{display: 'none'}}/>
                            <Button variant="success" onClick={handleUploadButtonClick}>Upload</Button>
                        </div>
                    </div>
                    {scheduleObj?.spiderArgs && <AGTable
                        data={scheduleObj?.spiderArgs}
                        keepRawHeaders={true}
                        gridRef={gridRef}
                        key={scheduleObj?.spiderArgs}
                        editableFields={[...new Set(scheduleObj?.spiderArgs?.flatMap(obj => Object.keys(obj)))]}
                    />}
                </div>
            </Form>
        </div>
      );    
};

export default SpiderScheduleForm;